import { createSelector } from '@reduxjs/toolkit';
import { selectPriceLabel } from './selectPriceLabel';
import { selectPrice } from 'shared/selectors/jsonQuery';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { EPageType } from 'shared/types/page';
import { TButtonSize } from 'shared/types/filters';

export const selectPriceFilter = createSelector(
  [selectPrice, selectPriceLabel, selectPageType, selectIsInlineFiltersRedesigned],
  (
    { gte: min = null, lte: max = null },
    label,
    pageType,
    isFiltersRedesignEnabled,
  ): {
    value: { min: number | null; max: number | null };
    label: typeof label;
    size: TButtonSize;
  } => ({
    value: { min, max },
    label,
    size: isFiltersRedesignEnabled && pageType === EPageType.MAIN ? 'small' : 'default',
  }),
);
